<section class="card bg-secondary border-0 py-1 p-md-2 p-xl-3 p-xxl-4 mb-4">
  <div class="card-header d-flex align-items-center justify-content-between">
    <h2 class="h4 mb-0"><i class="ai-message text-primary lead pe-1 me-2"></i>Comentarii
      <!-- <span class="fs-base fw-normal text-muted">({{comments.length}})</span> -->
    </h2>
  </div>
  <div class="card-body">
    <!-- Comment-->
    <div *ngFor="let comment of comments; first as first" [ngClass]="first? 'pb-4': 'py-4'" class="border-bottom">
      <div class="d-flex align-items-center pb-1 mb-3"><img class="rounded-circle object-fit-cover" [src]="comment.userImage" style="width:48px;height:48px;"
          [alt]="comment.userName">
        <div class="ps-3">
          <h6 class="mb-0">{{comment.userName}}</h6><span class="fs-sm text-muted">Postat acum {{comment.submittedDate | dfnsFormatDistanceToNowStrictPure}}</span>
        </div>
      </div>
      <p class="pb-2 mb-0">{{comment.content}}</p>
      <div class="d-flex align-items-center">
        <button *ngIf="userId" (click)="onReplyClick(comment.id)" ngbTooltip="Raspunde"
          class="nav-link fs-sm fw-semibold px-0 py-2" type="button"><i class="ai-redo fs-xl"></i></button>
        <button *ngIf="userId === comment.userId || isEventOwner" (click)="onDeleteCommentClick(comment.id)"
          ngbTooltip="Sterge" class="nav-link text-danger fs-sm fw-semibold px-0 py-2 ms-3" type="button"><i
            class="ai-trash fs-xl"></i></button>
      </div>

      <!-- Comment reply-->
      <div *ngFor="let reply of comment.replies" class="card card-body bg-gray border-0 mt-4">
        <div class="d-flex align-items-center pb-1 mb-3"><img class="rounded-circle object-fit-cover" [src]="reply.userImage" style="width:48px;height:48px;"
            [alt]="reply.userName">
          <div class="ps-3">
            <h6 class="mb-0">{{reply.userName}}</h6><span class="fs-sm text-muted">Postat acum {{reply.submittedDate | dfnsFormatDistanceToNowStrictPure}}</span>
          </div>
        </div>
        <p class="pb-2 mb-0">{{reply.content}}</p>
        <div class="d-flex align-items-center">
          <button *ngIf="reply.userId === userId || isEventOwner" (click)="onDeleteReplyClick(reply.commentId, reply.id)"
            ngbTooltip="Sterge" class="nav-link text-danger fs-sm fw-semibold px-0 py-2" type="button"><i
              class="ai-trash fs-xl"></i></button>
        </div>
      </div>
    </div>

    <!-- Loading template -->
    <div *ngIf="!comments">
      <div *ngFor="let item of [].constructor(3); first as first" [ngClass]="first? 'pb-4': 'py-4'"
        class="border-bottom placeholder-glow" aria-hidden="true">
        <span class="placeholder placeholder-sm col-7 me-2"></span>
        <span class="placeholder placeholder-sm col-4"></span>
        <span class="placeholder placeholder-sm col-8"></span>
        <span class="placeholder placeholder-sm col-4 me-2"></span>
        <span class="placeholder placeholder-sm col-6"></span>
      </div>
    </div>

    <!-- Comment form-->
    <div *ngIf="userId" #commentForm class="card border-0 pt-2 p-md-2 p-xl-3 p-xxl-4 mt-4">
      <div class="card-body">
        <h2 class="pb-2 pb-lg-3 pb-xl-4">{{actionDescription}}</h2>
        <form [formGroup]="form" (ngSubmit)="onCommentSubmit()" class="row g-4" autocomplete="off" novalidate>
          <div class="col-12">
            <!-- <label class="form-label" for="content">Comment</label> -->
            <textarea formControlName="content" [ngClass]="{'is-invalid': vs.hasErrors(form, 'content')}"
              class="form-control" rows="4" placeholder="Scrie comentariul aici..." id="content"></textarea>
            <div *ngIf="vs.hasErrors(form, 'content')" class="invalid-feedback">{{vs.getError(form, 'content')}}</div>
          </div>
          <div class="col-12 d-flex flex-column flex-sm-row justify-content-end">
            <button (click)="onCancelClick()" class="btn btn-secondary mb-3 mb-sm-0" type="button">Anuleaza</button>
            <button class="btn btn-primary ms-sm-3" type="submit">Adauga</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
